




































import Vue, { PropType } from 'vue';
import { DUNNING_CAMPAIGN, dunningCampaignFilterConfigMap } from '@/helpers/stats-utils';
import { IState } from '@/store/types';

interface IFilterOption {
  label: string;
  value: string;
}

interface IGroupFilterOption {
  key: string;
  label: string;
  options: IFilterOption[];
}

const baseFilterOptions = {
  [DUNNING_CAMPAIGN.TRIAL]: [false, true],
  [DUNNING_CAMPAIGN.RECOVERED]: [true, false],
  [DUNNING_CAMPAIGN.ACTIVE]: [true, false],
  [DUNNING_CAMPAIGN.BLUEPRINT]: [],
};

export default Vue.extend({
  name: 'DunningCampaignFilter',
  props: {
    include: {
      type: Array as PropType<string[]>,
      default: () => [DUNNING_CAMPAIGN.TRIAL, DUNNING_CAMPAIGN.RECOVERED, DUNNING_CAMPAIGN.ACTIVE, DUNNING_CAMPAIGN.BLUEPRINT],
    },
    exclude: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'All Sessions',
    },
    preselected: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    disabled: Boolean,
  },
  data() {
    return {
      selected: (this.preselected || []) as string[],
    };
  },
  computed: {
    campaignFilterOptions(): Record<string, any[]> {
      const state = this.$store.state as IState;
      // get options for segments (campaignBlueprintId audiences)
      const campaignBlueprintIds = Object.keys(state.campaignBlueprints);
      return {
        ...baseFilterOptions,
        [DUNNING_CAMPAIGN.BLUEPRINT]: campaignBlueprintIds,
      };
    },
    filterKeys(): string[] {
      return this.include.filter((d) => !this.exclude.includes(d));
    },
    selectionMap(): Record<string, string[]> {
      return this.filterKeys.reduce((acc, k) => {
        acc[k] = this.selected.filter((d) => d.split('.')[0] === k).map((d) => d.substring(d.indexOf('.') + 1));
        return acc;
      }, {} as Record<string, string[]>);
    },
    filterGroups(): IGroupFilterOption[] {
      const optionGroups = this.filterKeys.reduce((groups, k) => {
        const filterConfig = dunningCampaignFilterConfigMap[k];
        // filter needs array to be relevant
        // @ts-ignore
        if (['string[]', 'boolean[]', 'number[]'].includes(filterConfig.type) && this.campaignFilterOptions[k]) {
          // @ts-ignore
          const options = this.campaignFilterOptions[k].map((d) => ({
            value: `${k}.${d}`,
            label: filterConfig.optionToLabel
              ? filterConfig.optionToLabel(d, { getters: this.$store.getters, state: this.$store.state })
              : d.toString(),
          }));
          const group = {
            key: k,
            label: filterConfig.label,
            options,
          };
          groups.push(group);
        }
        return groups;
      }, [] as IGroupFilterOption[]);
      return optionGroups;
    },
  },
  methods: {
    handleFilterChange(proposedSelection: string[]) {
      // make sure only one from each group is selected. Namespaced by group key
      const oldSelection = [...this.selected];
      const added = proposedSelection.filter((x) => !oldSelection.includes(x));
      const intersection = oldSelection.filter((x) => proposedSelection.includes(x));
      const selectedKey = {} as Record<string, boolean>;
      const newSelection = added.concat(intersection).reduce((acc, d) => {
        const k = d.split('.')[0];
        if (!selectedKey[k]) {
          selectedKey[k] = true;
          acc.push(d);
        }
        return acc;
      }, [] as string[]);
      this.selected = newSelection;
      this.$emit('update', this.selectionMap);
    },
  },
});
